import { useEffect, useState } from "react"
import { getBmdStrandsForYear } from "../services/bmd.service"
import type { BmdStrand } from "../types/bmd.types"

export type UseBmdStrandsState = {
  strands: BmdStrand[]
  lockedTopicIds: Set<number>
  loading: boolean
  error: string | null
}

export function useBmdStrands(
  yearLevelId: number,
  subjectId: number,
  studentKey?: string,
): UseBmdStrandsState {
  const [strands, setStrands] = useState<BmdStrand[]>([])
  const [lockedTopicIds, setLockedTopicIds] = useState<Set<number>>(new Set())
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!yearLevelId || !subjectId) {
      setStrands([])
      setLockedTopicIds(new Set())
      setLoading(false)
      setError(null)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setError(null)

    getBmdStrandsForYear(
      {
        year_level_id: yearLevelId,
        subject_id: subjectId,
        student_key: studentKey,
      },
      controller.signal,
    )
      .then((res) => {
        setStrands(res.strands)
        setLockedTopicIds(new Set(res.locked_topic_ids || []))
        setLoading(false)
      })
      .catch((err) => {
        if (controller.signal.aborted) return
        setError(err?.message || "Failed to load diagnostics clusters")
        setStrands([])
        setLockedTopicIds(new Set())
        setLoading(false)
      })

    return () => {
      controller.abort()
    }
  }, [yearLevelId, subjectId, studentKey])

  return { strands, lockedTopicIds, loading, error }
}
